import React from 'react';
import { motion } from 'framer-motion';
export function ProblemSection() {
  return <section className="py-10 px-4 bg-[#111827] border-t border-gray-800" data-id="element-171">
      <div className="max-w-3xl mx-auto" data-id="element-172">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-173">
          <h2 className="text-2xl md:text-3xl font-black text-white mb-6 text-center leading-tight" data-id="element-174">
            Si querés mejorar tu vida, dejame hacerte una pregunta honesta
          </h2>

          <div className="space-y-4 text-base md:text-lg text-gray-300 font-medium" data-id="element-175">
            <p className="font-bold text-xl text-[#8FF650]" data-id="element-176">
              ¿Te pasa que el día termina… y sentís que no avanzaste nada en tu
              crecimiento personal?
            </p>

            <p data-id="element-177">No porque no quieras mejorar.</p>
            <p data-id="element-178">No porque no tengas interés en aprender.</p>
            <p className="bg-[#8FF650]/20 text-[#8FF650] inline-block px-2 py-1 font-bold rounded-sm" data-id="element-179">
              Sino porque el tiempo se te va en pequeñas cosas todos los días.
            </p>

            <p className="italic text-gray-400" data-id="element-180">
              Mientras manejas. Mientras entrenas. Mientras esperas algo.
              Mientras haces tareas rutinarias.
            </p>

            <p className="font-bold text-white text-xl" data-id="element-181">
              Horas que desaparecen sin darte cuenta.
            </p>
          </div>

          <div className="mt-8 bg-gray-900 p-6 md:p-8 rounded-2xl shadow-xl border border-gray-800" data-id="element-182">
            <h3 className="text-2xl font-black text-white mb-4 border-b-2 border-[#8FF650] pb-2 inline-block" data-id="element-183">
              El problema que casi nadie nota
            </h3>

            <p className="text-lg mb-4 text-gray-300" data-id="element-184">
              La mayoría de las personas desperdicia entre{' '}
              <span className="font-black text-[#8FF650]" data-id="element-185">
                2 y 4 horas al día
              </span>
              .
            </p>

            <ul className="space-y-2 mb-6 text-base font-bold text-gray-400" data-id="element-186">
              <li className="flex items-center gap-2" data-id="element-187">❌ aprendizaje</li>
              <li className="flex items-center gap-2" data-id="element-188">
                ❌ crecimiento personal
              </li>
            </ul>

            <p className="text-lg font-bold mb-4 text-white" data-id="element-189">
              Las personas que crecen más rápido en la vida tienen algo en
              común:
            </p>
            <p className="text-xl font-black text-black mb-6 bg-[#8FF650] inline-block px-2 py-1 rounded-sm" data-id="element-190">
              Consumen mejores ideas.
            </p>

            <p className="text-base font-bold mb-3 text-white" data-id="element-191">
              Ideas que cambian:
            </p>
            <ul className="grid grid-cols-1 md:grid-cols-2 gap-3 mb-6 text-base font-bold text-gray-300" data-id="element-192">
              <li className="flex items-center gap-2" data-id="element-193">● su forma de pensar</li>
              <li className="flex items-center gap-2" data-id="element-194">● su disciplina</li>
              <li className="flex items-center gap-2" data-id="element-195">
                ● su visión del dinero
              </li>
              <li className="flex items-center gap-2" data-id="element-196">● su mentalidad</li>
              <li className="flex items-center gap-2" data-id="element-197">● sus hábitos</li>
            </ul>

            <div className="bg-[#8FF650]/10 p-5 rounded-xl border-l-4 border-[#8FF650]" data-id="element-198">
              <p className="text-lg font-bold text-[#8FF650]" data-id="element-199">
                Pero hay un problema.
              </p>
              <p className="text-base text-gray-300 mt-1" data-id="element-200">
                Leer todos los libros que podrían ayudarte tomaría años.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}